import { Box } from "@mui/material";
import ItemsContent from "../../components/entityGrid/ItemsContent";
import Navbar from "../../components/Navbar";
import { useEffect, useState } from "react";
import { useApp } from "../../hooks/useApp";

// Default AI Feature asset template
const defaultAIFeatureAsset = {
  id: "",
  Title: "",
  privateId: "",
  video: "",
  Image: "",
  desc: "",
  editorUrl: "",
  status: "OK",
};

export default function AiFeatures() {
  const [asset, setAsset] = useState([defaultAIFeatureAsset]);
  const [loader,setLoader] = useState(true);

  const { aiFeatures } = useApp("ai_features");

  useEffect(() => {
    setAsset(aiFeatures)
    setLoader(false)
  },[aiFeatures])

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Navbar />
      <ItemsContent assets={asset} loader={loader} url={'/ai-features'}/>
    </Box>
  );
}
